import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_player-play",
  "use": "icon_player-play-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon_player-play\"><path stroke=\"currentColor\" stroke-linecap=\"round\" d=\"m6 3 14 9-14 9V3Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol